<template>
    <div>
        <el-card>
            <div class="boxClass">
                <span>变更统计</span>
                <div>
                    <router-link :to="{ path: '/changeEventStatis'}">
                        <span>变更事件统计</span>
                    </router-link>
                    <router-link :to="{ path: '/changeResultStatis'}">
                        <span>变更结果统计</span>
                    </router-link>
                    <router-link :to="{ path: '/urgentChangeStatis'}">
                        <span>紧急变更统计</span>
                    </router-link>
                </div>
                
            </div>
        </el-card>
    </div>
</template>

<script>
    
    export default {
        
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .boxClass{
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        &>span{
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 10px;
        }
        &>div{
            display: flex;
            flex-wrap:wrap;
            span{
                color:gray!important;
                margin-right: 30px;
            }
        }
    }
</style>